import { render, staticRenderFns } from "./autoria-index.vue?vue&type=template&id=095414cf"
import script from "./autoria-index.vue?vue&type=script&lang=js"
export * from "./autoria-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports